import { AgxBodyText, AgxColumn, AgxHeader } from '@urbanx/agx-ui-components'
import clsx from 'clsx'
import {
  ExecutiveKeyMetricsResponse,
  KeyMetric,
} from 'services/functions/rex/reporting/useExecutiveKeyMetrics'
import formatMetricsValue from './formatMetricsValue'

interface TableKeyMetricsProps {
  keyMetricsData: ExecutiveKeyMetricsResponse | undefined
}

const TableKeyMetric = ({ metric }: { metric: KeyMetric }) => {
  const varianceClasses = clsx('breakeven-cell', 'strong', {
    negative: metric.variance < 0,
    positive: metric.variance >= 0,
  })

  const { title, settled, projectedSettled, budget, variance, metricType } = metric

  return (
    <div className="breakeven-table-row">
      <AgxBodyText medium extraClasses="breakeven-cell left strong">
        {title}
      </AgxBodyText>
      <AgxBodyText small extraClasses="breakeven-cell">
        {formatMetricsValue(settled, metricType, 1)}
      </AgxBodyText>
      <AgxBodyText medium extraClasses="breakeven-cell strong">
        {formatMetricsValue(projectedSettled, metricType, 1)}
      </AgxBodyText>
      <AgxBodyText small extraClasses="breakeven-cell">
        {formatMetricsValue(budget, metricType, 1)}
      </AgxBodyText>
      <AgxBodyText extraClasses={varianceClasses}>
        {formatMetricsValue(variance, metricType, 1)}
      </AgxBodyText>
    </div>
  )
}

const TableKeyMetrics = ({ keyMetricsData }: TableKeyMetricsProps) => {
  if (!keyMetricsData) return null

  const { period, metrics } = keyMetricsData  

  return (
    <AgxColumn extraClasses="metrics-data">
      <AgxColumn>
        <AgxHeader size={3}>Key Metrics</AgxHeader>
        <AgxBodyText medium>{period}</AgxBodyText>
      </AgxColumn>
      <div className="breakeven-table">
        <div className="breakeven-table-header">
          <AgxBodyText extraClasses="breakeven-blank">.</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">Settled</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">
            Projected Settled
          </AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">Budget</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">
            Variance Expected
          </AgxBodyText>
        </div>
        {metrics?.map((row, index) => (
          <TableKeyMetric key={index} metric={row} />
        ))}
      </div>
    </AgxColumn>
  )
}

export default TableKeyMetrics
